import type { KarmaUser } from "@/lib/karma/types";

export function computeProfileCompletion(user: KarmaUser) {
  const missing: string[] = [];

  const checks: Array<{ ok: boolean; missingLabel: string }> = [
    { ok: (user.displayName ?? "").trim().length > 1, missingLabel: "İsim" },
    { ok: Boolean(user.birthDate?.year), missingLabel: "Doğum tarihi" },
    { ok: (user.photos?.length ?? 0) > 0, missingLabel: "Fotoğraf" },
    { ok: (user.bio ?? "").trim().length >= 20, missingLabel: "Bio (en az 20 karakter)" },
    { ok: (user.city ?? "").trim().length > 0, missingLabel: "Şehir" },
    { ok: Boolean(user.intent), missingLabel: "Niyet" },
  ];

  for (const c of checks) {
    if (!c.ok) missing.push(c.missingLabel);
  }

  const completed = checks.length - missing.length;
  const percent = Math.round((completed / checks.length) * 100);

  return { percent, missing };
}
